<template lang="">
    <div class="mt-2" style="background-color: white">
          <div class="section">
            <div class="card mb-2">
              <img src="/assets/img/sample/photo/wide0.jpg" class="card-img-top" alt="image">
              <div class="card-body placeholder-glow">
                <h6 class="card-subtitle">
                  <span class="placeholder col-4"></span>
                </h6>
                <h5 class="card-title">
                  <span class="placeholder col-5"></span>
                </h5>
                <p class="card-text">
                  <span class="placeholder col-5"></span>
                  <span class="placeholder col-6"></span>
                  <span class="placeholder col-8"></span>
                  <span class="placeholder col-3"></span>
                </p>
              </div>
            </div>
            <div class="card mb-2">
              <img src="/assets/img/sample/photo/wide0.jpg" class="card-img-top" alt="image">
              <div class="card-body placeholder-glow">
                <h6 class="card-subtitle">
                  <span class="placeholder col-4"></span>
                </h6>
                <h5 class="card-title">
                  <span class="placeholder col-5"></span>
                </h5>
                <p class="card-text">
                  <span class="placeholder col-5"></span>
                  <span class="placeholder col-6"></span>
                  <span class="placeholder col-8"></span>
                  <span class="placeholder col-3"></span>
                </p>
              </div>
            </div>
            <div class="card">
              <img src="/assets/img/sample/photo/wide0.jpg" class="card-img-top" alt="image">
              <div class="card-body placeholder-glow">
                <h6 class="card-subtitle">
                  <span class="placeholder col-4"></span>
                </h6>
                <h5 class="card-title">
                  <span class="placeholder col-5"></span>
                </h5>
                <p class="card-text">
                  <span class="placeholder col-5"></span>
                  <span class="placeholder col-6"></span>
                  <span class="placeholder col-8"></span>
                  <span class="placeholder col-3"></span>
                </p>
              </div>
            </div>
          </div>
  
        </div>
</template>
<script>
export default {
    name: 'placeholder'
}
</script>
<style lang="">
    
</style>